import NavVM from './nav-vm';
import Vue from 'vue';

import 'libs/vue-extensions';

export default {
  init (element) {
    new Vue(NavVM).$mount(element);
  }
};
